import React, {Component} from 'react';
import SideBar from './sidebar/SideBar';
import Nav from './Header/Nav';
import DevelopRequest from './components/DevelopRequest';
import Footer from './components/Footer';
import axios from 'axios';
import Subscribe from './components/Subscribe';

class Gallery extends Component {
    constructor(props){
        super(props);
        this.state = {
            isLoaded: false,
            persons: []
        };
    }

    componentDidMount(){
        axios.get(`https://codeflarelimited.com/api/fetch_images.php`)
          .then(res => {
            const persons = res.data;
             this.setState({
                  isLoaded: true,
               })
               this.setState({ persons });
          })
      }
  

    render(){
        const {isLoaded} = this.state;
        if(!isLoaded){
            return <div style={{height:'100vh', overflow:'hidden'}}> 
                <SideBar />
                <Nav />
                <div style={{height:'21vh'}}></div>
                <section>
  <div class="skeleton-container">
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
    <div class="card-skeleton">
      <div class="animated-background"> 
        <div class="card-skeleton-img"></div>
        <div class="skel-mask-container">
          <div class="skel-mask skel-mask-1"></div>
          <div class="skel-mask skel-mask-2"></div>
          <div class="skel-mask skel-mask-3"></div>
          <div class="skel-mask skel-mask-4"></div>
          <div class="skel-mask skel-mask-5"></div>
          <div class="skel-mask skel-mask-6"></div>
        </div>
      </div>
    </div>
  </div>
</section>
</div>;
        }

        else{           
            return(
                <div id="App" style={{background:'#333'}}>
                <SideBar />
                <Nav />
                <div style={{height:'21vh'}}></div>
                <h1 className="text-light text-center text-uppercase">Welcome to <span style={{color:'rgba(226, 155, 24, 0.945)'}}>Codeflare Gallery</span></h1>
                    <div style={{marginTop:'5vh'}} className="gallery">
                        {this.state.persons.map(person => 
                        <p key={person.id}>
                            <a target="_blank" rel="noopener noreferrer" href={person.image_file}>
                            <img src={person.image_file} alt={person.image_name} />
                            </a>
                            </p>
                            )}  
                    </div>
                    <DevelopRequest />
                    <Subscribe />
                    <Footer />
                    </div>

            );
        }

    }

}
export default Gallery;